import USPs from './USPs';

export default USPs;